import { styled } from '@linaria/react';

export const Section = styled.div<{ $locked: boolean }>`
  display: flex;
  flex-direction: column;
  opacity: ${({ $locked }) => ($locked ? 0.5 : 1)};
  pointer-events: ${({ $locked }) => ($locked ? 'none' : 'auto')};
`;
